import React from 'react';
import * as utils from "../utils";
import Contact from "./Contact";

//Nedbetalingslån
class RepaymentLoan extends React.Component {

    render() {
        var loans = this.props.loans;
        var indexType = this.props.indexType;
        var summary = this.props.summary;
        var indexLoanLast;
        var showInfo = false;

        return  <div id={'collapse' + indexType} className='panel-collapse collapse' aria-labelledby={'heading' + indexType}>
            <div>
                <div className="d-xl-none">
                    <div key={indexType} className='card-body list padding-0'>
                        <table className="tableLoanCol">
                            <tbody>
                            {loans.map(function (loan, indexLoan) {
                                indexLoanLast = indexLoan;
                                if (utils.isShowingUpdatetMarking(loan.receivedTime)) {
                                    showInfo = true;
                                }
                                return (
                                    <React.Fragment>
                                    <tr className={utils.tableStripes(indexLoan, false)}>
                                        <th>Kreditor</th>
                                        <td className="bold">{loan.financialInstitutionName}</td>
                                    </tr>
                                    <tr className={utils.tableStripes(indexLoan, false)}>
                                        <th>Opprinnelig lånebeløp</th>
                                        <td>kr {utils.formatNumber(loan.originalBalance)}</td>
                                    </tr>
                                    <tr className={utils.tableStripes(indexLoan, false)}>
                                        <th>Rentebærende saldo (restlån)</th>
                                        <td>kr {utils.formatNumber(loan.balance)}</td>
                                    </tr>
                                    <tr className={utils.tableStripes(indexLoan, false)}>
                                        <th>Gjenværende terminer</th>
                                        <td>{loan.terms}</td>
                                    </tr>
                                    <tr className={utils.tableStripes(indexLoan, false)}>
                                        <th>Nominell rente</th>
                                        <td>{utils.formatNumber(loan.nominalInterestRate)} %</td>
                                    </tr>
                                    <tr className={utils.tableStripes(indexLoan, false)}>
                                        <th>Gebyr</th>
                                        <td>kr {utils.formatNumber(loan.installmentCharges)}</td>
                                    </tr>
                                    <tr className={utils.tableStripes(indexLoan, false)}>
                                        <th>Terminlengde</th>
                                        <td>{utils.getPeriod(loan.installmentChargePeriod)}</td>
                                    </tr>
                                    <tr className={utils.tableStripes(indexLoan, false)}>
                                        <th>Medlåntaker</th>
                                        <td>{utils.coborrower(loan.coBorrower)}</td>
                                    </tr>
                                    <tr className={utils.tableStripes(indexLoan, false)}>
                                        <th>Oppdatert i Gjeldsregisteret</th>
                                        <td>{loan.receivedTime} <utils.checkUpdatetMarking datetime={loan.receivedTime}/></td>
                                    </tr>
                                    <tr className={utils.tableStripes(indexLoan, false)}>
                                        <th>Oppdatert hos kreditor</th>
                                        <td>{loan.processedTime}</td>
                                    </tr>
                                    <tr className={utils.tableStripes(indexLoan, true)}>
                                        <th>Melding om feil</th>
                                        <td><Contact loan={loan}/></td>
                                    </tr>
                                    </React.Fragment>
                                )
                            })}
                            <tr style={{borderBottomWidth: '0px'}} className={utils.tableStripes(indexLoanLast+1, true)}>
                                <td className="sum sumPadding">SUM Opprinnelig lånebeløp</td>
                                <td className="sum sumPadding">NOK {utils.formatNumber(summary.totalCreditLimitRepaymentLoan)}</td>
                            </tr>
                            <tr style={{borderBottomWidth: '0px'}} className={utils.tableStripes(indexLoanLast+1, true)}>
                                <td className="sum">SUM Rentebærende saldo</td>
                                <td className="sum">NOK {utils.formatNumber(summary.totalBalanceRepaymentLoan)}</td>
                            </tr>
                            <utils.showUpdatetMarkingInfo showInfo={showInfo} indexLoanLast={indexLoanLast+1} colspan={2}/>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="d-none d-xl-block">
                    <div key={indexType} className='card-body list padding-0'>
                        <table className="tableLoanRow">
                            <tbody>
                            <tr>
                                <th className="headerLeft">Kreditor</th>
                                <th className="headerRight">Opprinnelig<br/>lånebeløp kr</th>
                                <th className="headerRight">Rentebærende<br/>saldo kr (restlån)</th>
                                <th className="headerRight">Gjenværende<br/>terminer</th>
                                <th className="headerRight">Nominell<br/>rente %</th>
                                <th className="headerRight">Gebyr<br/>kr</th>
                                <th className="headerLeft">Terminlengde</th>
                                <th className="headerLeft">Medlåntaker</th>
                                <th className="headerLeft">Oppdatert i<br/>Gjeldsregisteret</th>
                                <th className="headerLeft">Oppdatert hos<br/>kreditor</th>
                                <th className="headerLeft">Melding<br/>om feil</th>
                            </tr>
                            {loans.map(function (loan, indexLoan) {
                                indexLoanLast = indexLoan;
                                if (utils.isShowingUpdatetMarking(loan.receivedTime)) {
                                    showInfo = true;
                                }
                                return (
                                    <tr>
                                        <td className="cellLeftBold">{loan.financialInstitutionName}</td>
                                        <td className="cellRight nowrap">{utils.formatNumber(loan.originalBalance)}</td>
                                        <td className="cellRight nowrap">{utils.formatNumber(loan.balance)}</td>
                                        <td className="cellRight nowrap">{loan.terms}</td>
                                        <td className="cellRight nowrap">{utils.formatNumber(loan.nominalInterestRate)}</td>
                                        <td className="cellRight nowrap">{utils.formatNumber(loan.installmentCharges)}</td>
                                        <td className="cellLeft nowrap">{utils.getPeriod(loan.installmentChargePeriod)}</td>
                                        <td className="cellLeft nowrap">{utils.coborrower(loan.coBorrower)}</td>
                                        <td className="cellLeft"><utils.wrapDateTime datetime={loan.receivedTime}/> <utils.checkUpdatetMarking datetime={loan.receivedTime}/></td>
                                        <td className="cellLeft"><utils.wrapDateTime datetime={loan.processedTime}/></td>
                                        <td className="cellLeft"><Contact loan={loan}/></td>
                                    </tr>
                                )
                            })}
                            <tr style={{borderBottomWidth: '0px'}}>
                                <td className="cellLeft cellSum">SUM</td>
                                <td className="cellRight cellSum nowrap">{utils.formatNumber(summary.totalCreditLimitRepaymentLoan)}</td>
                                <td className="cellRight cellSum nowrap">{utils.formatNumber(summary.totalBalanceRepaymentLoan)}</td>
                                <td className="cellRight cellSum" colSpan={8}>&nbsp;</td>
                            </tr>
                            <utils.showUpdatetMarkingInfo showInfo={showInfo} indexLoanLast={indexLoanLast} colspan={13}/>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    }
}

export default RepaymentLoan;